const AdminPages = {
  schools: "/Schools",
  schoolData: "/School-Data"

}

const CommonPages = {
  dashboard: "/Dashboard",
  login: "/",
  authentication: "/Authentication",
  registration: "/Registration",
  addPassword: "/Password",
  updatePassword: "/UpdatePassword",
  UpdateProfile: "/Update-Profile",
  EnterEmail: "/ForgotPasswordEnterEmail",
  EnterOTPToChangePassword: "/EnterOTPToChangePassword/:email",
  setNewPassword: "/SetNewPassword",
  sessionExpired: "/SessionExpired",
  LoadingPage: "/LoadingPage",
  TestPage: "/Test"
}

const SchoolPages = {
  subjectOverview: "/Overview",
  subjectMarking: "/Marking",
  subjectMarkings: "/Markings",
  topicMarkEditor: "/MarkEditor/:categoryName/:subjectName/:_subjectClassId/:_classId/:year/:_description/:identifier",
  Assessment: "/Assessment",
  classHome: "/ClassHome",
  editMarks: "/mark/:categoryName/:subjectName/:_subjectClassId/:_classId/:year/:_description/:identifier",
}

const SchoolAdmin = {
  schoolAdmin: "/SchoolAdmin",
}

const SuperAdmin = {
  superAdmin: "/SuperAdmin"
}

const InviteUser = {
  newUser: "/NewUser",
  newUser_: "/newUser",
  setPassword: "/SetPassword"
}

const RegistrationProcess = {
  b2bRegister: "/B2BRegister",
  b2cRegister: "/B2CRegister"
}

const PupilProgress = {
  pupilTable: "/PupilProgress",
  lineGraph: "/LineGraph",
}

const ClassesPages = {
  classesInfo: "/Classes"
}

const BigPicturePages = {
  bigPictuePredictedProgress: "/BP_PPR",
  bigPictueEndOfYearPrediction: "/BP_EoYP",
  curriculumCoverage: "/Curriculum_Coverage",
  demographics: "/Demo graphics",
  landingPageBigPic: "/BP_landing",
  progress: "/BP_progress",
}

const topicMarkEditor = (categoryName, subjectName, _subjectClassId, _classId, year, _description, identifier) => `/MarkEditor/${categoryName}/${subjectName}/${_subjectClassId}/${_classId}/${year}/${_description}/${identifier}`;

const editMarks = (categoryName, subjectName, _subjectClassId, _classId, year, _description, identifier) => `/mark/${categoryName}/${subjectName}/${_subjectClassId}/${_classId}/${year}/${_description}/${identifier}`;

export { AdminPages, BigPicturePages, CommonPages, PupilProgress, SchoolPages, SchoolAdmin, InviteUser, RegistrationProcess, topicMarkEditor, editMarks, ClassesPages, SuperAdmin };